var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpLogoWhiteTxt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 587,
    height: 75,
    viewBox: "0 0 587 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.4449 24.525L61.5827 2.68129C59.5211 0.835472 56.815 -0.123211 54.0512 0.0131527C51.2874 0.149517 48.6888 1.36993 46.8189 3.40973L26.1761 25.5553C24.4909 24.6099 22.536 24.2608 20.6278 24.5645C18.7195 24.8682 16.9696 25.8069 15.6611 27.2288L10.2967 32.9794C8.74866 34.6484 7.92696 36.8641 8.0124 39.1389C8.09785 41.4138 9.08344 43.5615 10.7524 45.1097L10.7692 45.1257L31.5002 63.9657C33.049 65.3476 35.0292 66.1496 37.1032 66.2351C39.1772 66.3206 41.2166 65.6842 42.8739 64.4344L52.4411 73.0219C53.9803 74.381 55.9883 75.0873 58.0394 74.9911C60.0905 74.8948 62.0235 74.0036 63.4286 72.5063L69.8655 65.5969C70.5635 64.86 71.1059 63.99 71.4603 63.0389C71.8146 62.0877 71.9737 61.075 71.928 60.061C71.9119 58.5248 71.4333 57.0292 70.5546 55.7691L86.0046 38.9878C87.8322 36.988 88.7982 34.3487 88.6935 31.6416C88.5887 28.9345 87.4215 26.3776 85.4449 24.525ZM40.4242 57.7857L39.0086 59.2022C38.5697 59.5883 38.0051 59.8013 37.4205 59.8013C36.8359 59.8013 36.2713 59.5883 35.8324 59.2022L15.2317 40.4522C14.8731 40.0508 14.6748 39.5313 14.6748 38.993C14.6748 38.4547 14.8731 37.9352 15.2317 37.5338L20.3824 31.6107C20.8072 31.1968 21.3769 30.9652 21.97 30.9652C22.5631 30.9652 23.1328 31.1968 23.5577 31.6107L36.9058 43.666L53.4714 26.4994C53.9289 26.0484 54.5456 25.7955 55.188 25.7955C55.8304 25.7955 56.4471 26.0484 56.9046 26.4994L62.4414 31.5619C62.8082 31.9017 63.05 32.3552 63.1277 32.8491C63.1464 32.934 63.1464 33.022 63.1277 33.1069C63.1362 33.7057 62.924 34.2868 62.5314 34.7391L40.4242 57.7857ZM81.3246 34.7391L61.5827 56.1975L65.1452 59.3738C65.3838 59.6218 65.5171 59.9526 65.5171 60.2968C65.5171 60.6409 65.3838 60.9717 65.1452 61.2197L58.7074 68.1722C58.4381 68.4195 58.0858 68.5567 57.7202 68.5567C57.3546 68.5567 57.0023 68.4195 56.733 68.1722L47.3768 59.5885L67.3333 38.5163C68.9085 36.9069 69.8133 34.7592 69.8646 32.5078C69.7112 30.223 68.6811 28.0858 66.9892 26.5425L61.2817 21.2204C59.5469 19.6543 57.2671 18.831 54.932 18.9273C52.5968 19.0235 50.3925 20.0316 48.7924 21.735L36.6049 34.6107L31.2405 29.6325L51.5402 7.7016C52.2941 6.96531 53.2925 6.53213 54.3453 6.48458C55.398 6.43704 56.4314 6.77846 57.2486 7.44379L81.0677 29.1563C81.8349 29.8537 82.2972 30.8248 82.3549 31.86C82.3857 32.3846 82.3103 32.9099 82.1333 33.4046C81.9562 33.8993 81.6812 34.3532 81.3246 34.7391Z",
    fill: "url(#paint0_linear_2634_2452)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.92 14.6044H108.469V54.7369H133.282V60.4322H101.922L101.92 14.6044Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.812 14.6044H147.359V60.4322H140.812V14.6044Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.913 55.1944L159.335 50.0879C162.739 53.1657 168.566 55.3913 174.458 55.3913C182.38 55.3913 185.784 52.3144 185.784 48.3207C185.784 37.126 158.025 44.1957 158.025 27.1744C158.025 20.1038 163.525 14.0813 175.571 14.0813C180.939 14.0813 186.504 15.5213 190.301 18.1397L188.144 23.3776C184.151 20.8238 179.634 19.6454 175.574 19.6454C167.784 19.6454 164.445 22.9191 164.445 26.9129C164.445 38.1076 192.204 31.1026 192.204 47.9279C192.204 54.9329 186.573 60.9591 174.462 60.9591C167.453 60.9563 160.579 58.5994 156.913 55.1944Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.202 20.3006H194.49V14.6044H232.396V20.3006H216.684V60.4322H210.202V20.3006Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.531 14.6044H246.079V60.4322H239.531V14.6044Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M299.237 14.6044V60.4322H293.869L266.372 26.2575V60.4322H259.826V14.6044H265.194L292.688 48.7791V14.6044H299.237Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M344.737 37.2563H351.018V55.1297C346.435 58.9922 340.085 60.9563 333.669 60.9563C319.593 60.9563 309.25 51.0704 309.25 37.5188C309.25 23.9672 319.593 14.0813 333.8 14.0813C341.066 14.0813 347.22 16.5029 351.411 21.151L347.351 25.2104C343.555 21.5447 339.234 19.9079 334.061 19.9079C323.455 19.9079 315.796 27.3057 315.796 37.5188C315.796 47.6007 323.455 55.1297 333.996 55.1297C337.858 55.1297 341.459 54.2785 344.733 52.1832L344.737 37.2563Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M386.438 15.6356H368.432V59.4009H376.559V46.7709H386.438C397.942 46.7709 405.07 40.8319 405.07 31.2084C405.07 21.5128 397.942 15.6356 386.438 15.6356ZM386.063 39.8944H376.559V22.5131H386.063C393.188 22.5131 396.879 25.7006 396.879 31.2037C396.879 36.7069 393.188 39.8944 386.063 39.8944ZM424.513 15.6356L404.819 59.4009H413.197L417.509 49.2759H439.392L443.768 59.4009H452.271L432.516 15.6356H424.513ZM420.262 42.8953L428.452 23.7637L436.702 42.8953H420.262ZM494.474 31.2037C494.474 21.5128 487.349 15.6356 475.842 15.6356H457.837V59.4009H465.965V46.6509H475.842C476.406 46.6614 476.969 46.6404 477.53 46.5881L486.469 59.4009H495.222L485.157 45.0206C491.098 42.7078 494.474 37.8309 494.474 31.2037ZM475.467 39.9572H465.965V22.5131H475.467C482.592 22.5131 486.283 25.7006 486.283 31.2037C486.283 36.7069 482.595 39.9572 475.467 39.9572ZM497.287 15.6356H534.425V22.5131H519.92V59.4009H511.792V22.5131H497.287V15.6356ZM580.94 15.6356L563.813 43.9584V59.4009H555.686V44.0831L538.492 15.6356H547.182L559.999 36.9553L572.941 15.6356H580.94Z",
    fill: "url(#paint1_linear_2634_2452)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2634_2452",
    x1: 8.00643,
    y1: 37.5,
    x2: 88.6999,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#67C84D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#60C261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#4DB395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2F9AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2793FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#825AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9D56EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E24CE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E44CD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E84CB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EA4CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F74767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FF6C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFB200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2634_2452",
    x1: 368.432,
    y1: 37.5187,
    x2: 580.94,
    y2: 37.5187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#67C84D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#60C261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#4DB395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2F9AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2793FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#825AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9D56EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E24CE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E44CD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E84CB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EA4CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F74767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FF6C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFB200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpLogoWhiteTxt);
export default __webpack_public_path__ + "static/media/lp_logo_white_txt.f6148b6c06b82af0f68c6976fd75f7b2.svg";
export { ForwardRef as ReactComponent };